module.exports = __webpack_public_path__ + "img/Fabella_island.e38a41ec.png";